if (!window.customElements.get('gift-upsell')) {
	class GiftUpsell extends HTMLElement {
		connectedCallback() {
			this.updateVisibility(this.totalPrice, this.cartItemCount);
			this.onGiftRadioChangeListener = this.onGiftRadioChange.bind(this);
			this.giftRadiosElement = [...this.querySelectorAll('input')];
			this.giftRadiosElement.forEach((giftRadio) => {
				giftRadio.addEventListener('change', this.onGiftRadioChangeListener);
			});
			this.updateCheckedGift();
		}
		disconnectedCallback() {
			this.giftRadiosElement.forEach((giftRadio) => {
				giftRadio.removeEventListener('change', this.onGiftRadioChangeListener);
			});
		}
		disableAllRadios() {
			this.giftRadiosElement.forEach((giftRadio) => {
				giftRadio.disabled = true;
			});
		}
		enableAllRadios() {
			this.giftRadiosElement.forEach((giftRadio) => {
				giftRadio.disabled = false;
			});
		}
		async onGiftRadioChange(event) {
			if (!event.target.checked) return;
			this.disableAllRadios();
			const upsellGiftLevel = window.cartBarLevels.find((level) => level.type === 'upsellGift');
			upsellGiftLevel.giftId = this.selectedGiftId;
			this.updateCheckBoxesOverall();
			const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
			const giftUpsellChangeEvent = new CustomEvent('gift-upsell:change', {
				bubbles: true,
				detail: {
					cart,
				},
			});
			document.dispatchEvent(giftUpsellChangeEvent);
			this.enableAllRadios();
		}
		// disable-visibility-control
		get isOnProductPage() {
			return this.hasAttribute('on-product-page');
		}
		get totalPrice() {
			return parseInt(this.getAttribute('total-price'));
		}
		get cartItemCount() {
			return parseInt(this.getAttribute('cart-item-count'));
		}
		get threshold() {
			return parseInt(this.getAttribute('threshold'));
		}
		get countThreshold() {
			return parseInt(this.getAttribute('count-threshold'));
		}
		get cartUpdatePayload() {
			const isQualified = this.isQualified(this.totalPrice, this.cartItemCount);
			return this.giftRadiosElement.map((radio) => {
				return {
					[radio.value]: !isQualified ? 0 : radio.checked ? 1 : 0,
				};
			});
		}
		get selectedGiftId() {
			const selectedRadio = this.giftRadiosElement.find((radio) => radio.checked);
			return selectedRadio ? parseInt(selectedRadio.value) : null;
		}
		show() {
			this.removeAttribute('hidden');
		}
		hide() {
			this.setAttribute('hidden', true);
		}
		isQualified(cartTotalPrice, cartItemCount) {
			return !isNaN(this.threshold)
				? cartTotalPrice >= this.threshold
				: !isNaN(this.countThreshold)
					? cartItemCount >= this.countThreshold
					: false;
		}
		updateVisibility(cartTotalPrice, cartItemCount) {
			if (this.isOnProductPage) return;
			if (this.isQualified(cartTotalPrice, cartItemCount)) {
				this.show();
			} else {
				this.hide();
			}
		}
		updateCheckedGift() {
			const upsellGiftLevel = window.cartBarLevels.find((level) => level.type === 'upsellGift');
			this.giftRadiosElement.forEach((radio) => {
				radio.checked = parseInt(radio.value) === upsellGiftLevel.giftId;
			});
		}
		updateCheckBoxesOverall() {
			document.querySelectorAll('gift-upsell').forEach((giftUpsellElement) => {
				giftUpsellElement.updateCheckedGift();
			});
		}
	}

	window.customElements.define('gift-upsell', GiftUpsell);
}
